import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrame, ModalFrameFooter, ModalFrameInner, ModalFrameMessage } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./collabary-support.i18n.json'));
applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  onConfirm: () => void,
  onCloseModal: () => void
};

const ConfirmModal = (
  {
    onCloseModal,
    onConfirm
  }: Props
): JSX.Element => (
  <ModalFrame>
    <ModalFrameInner
      narrowContent
    >
      <ModalFrameMessage
        message={__t('collabary_support.confirmation_content')}
      />
      <ModalFrameFooter>
        <ActionButton
          color="tertiary"
          onClick={onCloseModal}
        >
          {__t('collabary_common.action_button.cancel')}
        </ActionButton>
        <ActionButton
          color="secondary"
          onClick={() => {
            onCloseModal();
            onConfirm();
          }}
        >
          {__t('collabary_common.action_button.confirm')}
        </ActionButton>
      </ModalFrameFooter>
    </ModalFrameInner>
  </ModalFrame>
);

export default ConfirmModal;
